const Error = (message) => {
  return `<li class="location-search__error">${message}</li>`;
};

export default Error;
